// Shared palette for auth screens — brutalist performance noir.
// Keep the same shape so legacy inline styles continue to compile;
// hex values shift to near-black + bone with teal reserved for CTAs.
export const A = {
  bg: "#050505",
  surface: "#0d0d0d",
  card: "#0e0e0e",
  cardHi: "#161616",
  border: "#1f1f1f",
  borderHi: "#2a2a2a",
  teal: "#12cfc0",
  tealLt: "#58e8de",
  tealDim: "#12cfc012",
  tealGlow: "#12cfc022",
  text: "#f5f5f5",
  sub: "#a1a1aa",
  coral: "#f0705f",
  pink: "#e878b0",
};
